import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    margin: 0,
    padding: '1rem 1.25rem',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.875rem',
    borderRadius: '0.5rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
  },

  headerLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  headerTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.5rem',

    '& h1': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      color: '#000000',
    },
  },

  tableBase: {
    width: '100%',
  },

  tableHeader: {
    '& th': {
      fontFamily: 'Nunito',
      fontWeight: '600',
      fontSize: '0.875rem',
      lineHeight: '2rem',
      textAlign: 'left',
      padding: '1rem',
      borderBottom: `1px solid ${getRGBA('#000000', 0.12)}`,
    },
  },

  tableNameSize: {
    width: '35%',
    padding: '0.25rem 1rem',
  },

  tableOthersSize: {
    width: '21%',
    padding: '0.25rem 1rem',
  },

  tableActionSize: {
    width: '2%',
    padding: '0.25rem 1rem',
  },

  tableBody: {
    '& td': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.75rem',
      textAlign: 'left',
      padding: '1rem',
      borderBottom: `1px solid ${getRGBA('#000000', 0.12)}`,
    },
  },

  title: {
    fontFamily: 'Sora',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#191C1A',
    margin: '1rem 0',
    marginTop: '2rem',
  },

  baseContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '1rem 0',
    padding: '0',
  },

  tableLable: {
    fontSize: '0.75rem',
    lineHeight: '20.02px',
    opacity: '0.75',
  },

  item: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',
  },

  itemTable: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: 'auto',
    margin: 0,
    borderBottom: '1px solid #E4E4E4',
    padding: '0.5rem 1rem',
  },

  itemIcon: {
    width: '2%',
    maxWidth: '2%',
  },

  itemHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.35rem',
    padding: '1.25rem',
    fontSize: '0.85rem',

    width: '20%',
    maxWidth: '20%',
  },

  itemDate: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.35rem',
    padding: '1.25rem',
    fontSize: '0.85rem',

    width: '24%',
    maxWidth: '24%',
  },

  itemStatus: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.35rem',
    padding: '0 1.25rem',
    fontSize: '0.85rem',

    width: '34%',
    maxWidth: '34%',
  },

  itemRegister: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.35rem',
    padding: '0 1.25rem',
    fontSize: '0.85rem',

    width: '18%',
    maxWidth: '18%',
  },

  itemFooter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '2%',
    maxWidth: '2%',
  },

  paperBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    borderRadius: '1rem',
    fontSize: '0.85rem',
    padding: '0 1rem',
    minHeight: '80px',
  },

  paperBoxContent: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
}))

export { useStyles }
